module.exports = __webpack_public_path__ + "img/silver.5e9bd313.svg";